import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'// 页面顶部进度条
import 'nprogress/nprogress.css'

import {fetch} from '../fetch/api'
import store from '../store'

import Layout from '../pages/Layout.vue'

const NotFoundComponent = () => import('../pages/404.vue')
// const Layout = () => import('../pages/Layout.vue')
const Users = () => import('../pages/Users.vue')
const Entry = () => import('../pages/Entry.vue')
const UsersCheck = () => import('../pages/UsersCheck.vue')
const UsersView = () => import('../pages/UsersView.vue')

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const routes = [
  {path: '*', redirect: '/404'},
  {path: '/404', component: NotFoundComponent},
  {path: '/', redirect: '/home'},
  {
    path: '/entry',
    name: 'Entry',
    title: '入职手续',
    visible: false,
    icon: '',
    component: Entry
  },
  {
    path: '/home',
    name: 'Home',
    title: '首页',
    visible: true,
    icon: '',
    meta: {
      id: 1,
      requireAuth: true
    },
    component: Layout,
    children: [
      {
        path: '/users/:action?',
        name: 'Users',
        title: '通讯录',
        icon: 'icon-drxx10',
        visible: true,
        meta: {
          id: 1,
          debug: false,
          requireAuth: true
        },
        component: Users
      },
      {
        path: '/check/:action?',
        name: 'Check',
        title: '审核',
        icon: 'icon-drxx34',
        number: 1,
        visible: true,
        meta: {
          id: 28,
          debug: true,
          requireAuth: true
        },
        component: UsersCheck
      },
      {
        path: '/apply/expense/:action?',
        name: 'applyExpense',
        title: '财务审批',
        number: 39,
        icon: 'icon-drxx30',
        visible: true,
        component: resolve => require(['@/pages/UsersApplyExpense.vue'], resolve),
        group: false,
        meta: {
          id: 29,
          requireAuth: true
        },
        children: [
          {
            path: '/apply/1',
            redirect: '/apply/expense/:action?',
            name: 'quit',
            title: '报销',
            icon: 'icon-drxx94',
            number: 1,
            visible: true
          },
          // {
          //   path: '/apply/2',
          //   redirect: '/apply/borrowing/:action?',
          //   name: 'borrowing',
          //   title: '借款',
          //   icon: 'icon-drxx42',
          //   number: 1,
          //   visible: true
          // },
        ]
      },
      {
        path: '/appgroups',
        name: 'appgroups',
        title: '申请',
        icon: 'icon-drxx37',
        number: 1,
        visible: false,
        group: true,
        meta: {
          id: 54,
          debug: true,
          requireAuth: true
        },
        // component: resolve => require(['@/pages/UsersApplyLeave.vue'], resolve),
        children: [
          // {
          //   path: '/apply/1',
          //   redirect: '/apply/quit/:action?',
          //   name: 'quit',
          //   title: '离职',
          //   icon: 'icon-drxx15',
          //   number: 1,
          //   visible: true
          // },
          // {
          //   path: '/apply/2',
          //   redirect: '/apply/job/:action?',
          //   name: 'job',
          //   title: '人才需求',
          //   icon: 'icon-drxx60',
          //   number: 1,
          //   visible: true
          // },
          // {
          //   path: '/apply/3',
          //   redirect: '/apply/leaving/:action?',
          //   name: 'leaving',
          //   title: '离职证明',
          //   icon: 'icon-drxx51',
          //   number: 1,
          //   visible: true
          // }
          // ,{
          //   path: '/apply/2',
          //   name: 'leave',
          //   redirect: '/apply/leave/:action?',
          //   title: '请假',
          //   icon: 'icon-drxx37',
          //   number: 1,
          //   visible: true
          // }
        ]
      },
      {
        path: '/office/:action?',
        name: 'leaveOffice',
        title: '办公登记',
        icon: 'icon-drxx22',
        number: 1,
        visible: false,
        component: resolve => require(['@/pages/Office.vue'], resolve),
        meta: {
          id: 41,
          debug: true,
          requireAuth: true
        }
      },
      {
        path: '/apply/borrowing/:action?',
        name: 'applyBorrowing',
        title: '用款申请',
        number: 0,
        icon: 'icon-drxx30',
        visible:  false,
        component: resolve => require(['@/pages/UsersBorrowing.vue'], resolve),
        group: true,
        meta: {
          id: 100,
          requireAuth: true
        }
      },
      {
        path: '/collect/data',
        name: 'collectData',
        title: '采集数据',
        icon: 'icon-drxx22',
        number: 1,
        visible: true,
        component: resolve => require(['@/pages/CollectData.vue'], resolve),
        meta: {
          id: 80,
          debug: true,
          requireAuth: true
        }
      },
      {
        path: '/documents/:action?',
        name: 'documents',
        title: '商品管理',
        icon: 'icon-shangpin-',
        number: 1,
        color: '#96d631',
        visible: true,
        component: resolve => require(['@/pages/Documents.vue'], resolve),
        meta: {
          id: 50,
          debug: false,
          requireAuth: true
        }
      },
      {
        path: '/apply/job/:action?',
        name: 'jobDemand',
        title: '人才需求',
        icon: 'icon-drxx60',
        number: 1,
        visible: false,
        component: resolve => require(['@/pages/JobDemand.vue'], resolve),
        meta: {
          id: 30,
          debug: true,
          requireAuth: true
        }
      },
      {
        path: '/apply/leaving/:action?',
        name: 'leaveCert',
        title: '离职证明',
        icon: 'icon-drxx51',
        number: 1,
        visible: false,
        component: resolve => require(['@/pages/UsersApplyLeave.vue'], resolve),
        meta: {
          id: 1,
          debug: true,
          requireAuth: true
        }
      },
      {
        path: '/apply/quit/:action?',
        name: 'leaveOffice',
        title: '离职申请',
        icon: 'icon-drxx37',
        number: 1,
        visible: false,
        component: resolve => require(['@/pages/UsersApplyQuit.vue'], resolve),
        meta: {
          id: 30,
          debug: true,
          requireAuth: true
        }
      },
      // {
      //   path: '/apply/leave/:action?',
      //   name: 'leaveOffice',
      //   title: '请假',
      //   icon: 'icon-drxx15',
      //   number: 1,
      //   visible: false,
      //   component: resolve => require(['@/pages/UsersApplyLeave.vue'], resolve),
      //   meta: {
      //     id: 31,
      //     debug: true,
      //     requireAuth: true
      //   }
      // },
      {
        path: '/user/entry/:id',
        name: 'EntryView',
        title: '入职手续审核',
        visible: false,
        icon: '',
        meta: {
          id: 19,
          debug: false,
          requireAuth: true
        },
        component: resolve => require(['@/pages/EntryView.vue'], resolve)
      },
      {
        path: '/user/:action/:id',
        name: 'UsersView',
        title: '查看员工资料',
        visible: false,
        meta: {
          id: 1,
          debug: false,
          requireAuth: true
        },
        component: UsersView
      },
      // {
      //   path: '/upload/data',
      //   name: 'UploadData',
      //   title: '上传经营数据',
      //   visible: false,
      //   meta: {
      //     id: 30,
      //     debug: false,
      //     requireAuth: true
      //   },
      //   component: resolve => require(['@/pages/UploadData.vue'], resolve)
      // },
      // {
      //   path: '/analysis/:action?',
      //   name: 'BusinessAnalysis',
      //   title: '经营分析',
      //   visible: true,
      //   icon: 'icon-yijianfenxi',
      //   color: '#0165eb',
      //   meta: {
      //     id: 34,
      //     debug: true,
      //     requireAuth: true
      //   },
      //   component: resolve => require(['@/pages/Analysis.vue'], resolve)
      // },
      {
        path: '/attend/:action?',
        name: 'UsersAttend',
        title: '考勤/薪资',
        visible: true,
        icon: 'icon-kaoqinchaxun',
        color: '#fbab2e',
        meta: {
          id: 34,
          debug: true,
          requireAuth: true
        },
        component: resolve => require(['@/pages/UsersAttend.vue'], resolve)
      },
      {
        path: '/me/:action?',
        name: 'Me',
        title: '我的',
        visible: false,
        meta: {
          id: 1,
          debug: false,
          requireAuth: true
        },
        component: resolve => require(['@/pages/Me.vue'], resolve)
      },
      {
        path: '/costs/:action?',
        name: 'Costs',
        title: '费用报备',
        icon: 'icon-drxx42',
        disabled: false,
        visible: false,
        meta: {
          id: 4,
          debug: false,
          requireAuth: true
        },
        component: resolve => require(['@/pages/Costs.vue'], resolve)
      },
      {
        path: '/report/:action?',
        name: 'reportForm',
        title: '应收款',
        icon: 'icon-drxx42',
        number: 1,
        visible: true,
        component: resolve => require(['@/pages/ReportForm.vue'], resolve),
        meta: {
          id: 55,
          debug: true,
          requireAuth: true
        }
      },
      {
        path: '/analysis/:action?',
        name: 'leaveOffice',
        title: '经营分析',
        icon: 'icon-xinxifenxi',
        number: 1,
        color: '#006ced',
        visible: true,
        component: resolve => require(['@/pages/BusinessAnalysis.vue'], resolve),
        meta: {
          id: 47,
          debug: true,
          requireAuth: true
        }
      },
      {
        path: '/contract/:action?',
        name: 'contract',
        title: '合同',
        icon: 'icon-drxx39',
        number: 1,
        color: '#006ced',
        visible: true,
        component: resolve => require(['@/pages/Contract.vue'], resolve),
        meta: {
          id: 68,
          debug: true,
          requireAuth: true
        }
      },
      {
        path: '/biding/:action?',
        name: 'bidingDocument',
        title: '标书',
        icon: 'icon-drxx23',
        number: 1,
        color: '#006ced',
        visible: false,
        component: resolve => require(['@/pages/Biding.vue'], resolve),
        meta: {
          id: 67,
          debug: true,
          requireAuth: true
        }
      },
      {
        path: '/groups/:action?',
        name: 'Author',
        title: '权限管理',
        icon: 'icon-drxx08',
        disabled: false,
        visible: true,
        meta: {
          id: 7,
          debug: false,
          requireAuth: true
        },
        component: resolve => require(['@/pages/Groups.vue'], resolve)
      },
      {
        id: 10,
        path: '/menus/:action?',
        name: 'Menus',
        title: '菜单管理',
        icon: 'icon-drxx11',
        disabled: false,
        visible: false,
        meta: {
          id: 10,
          debug: false,
          requireAuth: true
        },
        component: resolve => require(['@/pages/Menus.vue'], resolve)
      },
      {
        path: '/department',
        name: 'Department',
        title: '组织架构',
        icon: 'icon-drxx95',
        disabled: false,
        visible: false,
        meta: {
          id: 13,
          debug: false,
          requireAuth: true
        },
        component: resolve => require(['@/pages/Department.vue'], resolve)
      },
      {
        path: '/table',
        name: 'Table',
        title: '组织架构',
        icon: 'icon-drxx49',
        disabled: true,
        visible: false,
        meta: {
          id: 88,
          debug: false,
          requireAuth: true
        },
        component: resolve => require(['@/pages/Table.vue'], resolve)
      },
      {
        id: 27,
        path: '/wechat/:action?',
        name: 'EntryView',
        title: '微信管理',
        visible: false,
        icon: 'icon-cansaitubiaozhuanqu-',
        meta: {
          id: 27,
          debug: true,
          requireAuth: true
        },
        component: resolve => require(['@/pages/Wechat.vue'], resolve)
      },
      {
        path: '/message/:action?',
        name: 'Message',
        title: '消息中心',
        icon: 'icon-drxx49',
        visible: false,
        meta: {
          id: 30,
          debug: false,
          requireAuth: true
        },
        component: resolve => require(['@/pages/Message.vue'], resolve)
      },
      {
        path: '/logs',
        name: 'Logs',
        title: '系统日志',
        icon: 'icon-drxx49',
        visible: false,
        meta: {
          id: 30,
          debug: false,
          requireAuth: true
        },
        component: resolve => require(['@/pages/Logs.vue'], resolve)
      },
      {
        path: '/center',
        name: 'Center',
        title: '个人中心',
        visible: false,
        icon: '',
        meta: {
          id: 888,
          requireAuth: true
        },
        component: resolve => require(['@/pages/UserCenter.vue'], resolve)
      },
      {
        path: '/center/financial',
        name: 'Finance Center',
        title: '财务中心',
        icon: 'icon-drxx10',
        visible: false,
        meta: {
          id: 1,
          debug: false,
          requireAuth: true
        },
        component: resolve => require(['@/pages/FinancialCenter.vue'], resolve)
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    title: '登录',
    icon: 'icon-drxx08',
    visible: false,
    component: resolve => require(['@/pages/Login.vue'], resolve)
  }
]

/**
 * 添加全局导航钩子
 *
 */
// let storeFlag = null
let isLogged = false
let fetchMe = true

const auth = {
  isLogged: function (callback, errcallback) {
    let token = localStorage.getItem('token')
    if (token !== null && fetchMe) {
      fetchMe = false
      fetch('/auth/me')
        .then(res => {
          store.dispatch('setUserInfo', res)
          store.dispatch('setLoginState', true)
          isLogged = true
          // console.log(res)
          console.log('登录成功')
          callback()
        }).catch(() => {
          console.log('登录失败')
          errcallback()
          store.dispatch('setLoginState', false)
          // localStorage.removeItem('token')
        })
      setTimeout(() => {
        fetchMe = true
      }, 1000)
    }
  }
}

const router = new Router({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  store.dispatch('setLoadingState', true)
  // 路由配置meta requireAuth
  if (!store.state.logined && !to.matched.some(record => record.meta.isLoginPage)) {
    if (to.path !== '/home' && !isLogged) {
      next({
        path: '/home',
        query: { redirect: to.fullPath }
      })
    }
    auth.isLogged(() => {
      // if not, redirect to login page.
      if (to.query.redirect !== undefined && isLogged) {
        next({
          path: to.query.redirect
        })
      } else {
        next()
      }
    }, () => {
      next()
    })
    next()
  } else {
    next() // 确保一定要调用 next()
  }
  NProgress.done()
})

router.afterEach(() => {
  setTimeout(() => {
    store.dispatch('setLoadingState', false)
  }, 1000)
  if (store.state.userInfo.entry_status < 2 && router.path !== '/entry') {
    router.replace({'path': '/entry'})
  }
  NProgress.done()
})

export default router
